import { ProgramNames } from '../../../models/programs/Programs'
import { ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

export const SELF_CARE_APPS_PROGRAM = {
  programName: ProgramNames.SELF_CARE_APPS,
  blendedCareProgramId: null,
  customerPropertyId: ProgramCustomerPropertyId.mystrength_accesscode,

  displayLabels: {
    default: ProgramDisplayLabels.guidedSelfCare,
    clientProfile: 'Guided self-care coaching',
    sessionSummary: 'guided self care',
  },

  associatedProviderTypes: [],
  associatedProviderModalities: [],

  canRescheduleAppointment: false,
  selfPayEligible: false,

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.SELF_CARE_APPS],
    isFullTreatmentOption: true,
  },

  consents: [],
} satisfies ProgramConfig
